module.exports = __webpack_public_path__ + "static/media/regal-rush-crown+logo-white-bg-gold-400x240.872c1bfd.png";